import React from "react";
import "./ProjectCard.css";
import { Link } from "react-router-dom";

const ProjectCard = ({ title, img, alt, linkUrl }) => {
  const name = title.toLowerCase().split("-").join(".").split(" ").join("-");

  return (
    <div className="projectCard containa ">
      <div className="img containa portfolio__img w-full">
        <img src={img} alt={alt} className="h-1/2" />
        <div className="portfolio__link">
          <Link to={name}> Click To View Details</Link>
        </div>
        <h3 className="project title">{title}</h3>
      </div>
    </div>
  );
};

export default ProjectCard;
